// Registry of reviewed local editorial guides.
//
// Three independent controls (none of them is a CMS or a database):
//   1. Preview  : build-time env VITE_EDITORIAL_PREVIEW=1 renders any guide whose status is draft/approved/published.
//                 Set it only for local review builds and a protected Vercel Preview, never for Production.
//   2. Editorial: the fixture's own `status` ("draft" -> "approved" -> "published"), changed only by a reviewed commit.
//                 Only "published" renders without the preview flag. The validator requires a named reviewer,
//                 approval date, and verified Amazon listings before approved/published are accepted.
//   3. Indexing : seo/sitemap-manifest.json (approved paths). Rendering NEVER implies indexability: a published guide
//                 is still noindex until its manifest entry is approved in a separate step.
import dellSmallDesks from './dellSmallDesks.json';

const GUIDES = { [dellSmallDesks.slug]: dellSmallDesks };

export const editorialPreviewEnabled = () => import.meta.env?.VITE_EDITORIAL_PREVIEW === '1';

export function getEditorialGuide(slug, previewEnabled = editorialPreviewEnabled()) {
  const guide = GUIDES[slug];
  if (!guide) return null;
  return previewEnabled || guide.status === 'published' ? guide : null;
}

export const editorialGuides = GUIDES;
